<template>
    <div>
        <v-card flat class="pa-5">
             <v-row justify="space-between" align="stretch" class="mx-5">
                <v-col cols="6">
                    <h3>Staff
                        <v-btn icon @click="refreshData">
                            <v-icon>fas fa-redo-alt</v-icon>
                        </v-btn>
                    </h3>
                </v-col>
                <v-col cols="6">
                    <v-text-field dense v-model="search" append-icon="icon-q-search" label="Search" single-line hide-details v-on:keyup="maybeSearch" @click:append="refreshData"></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-data-table v-on:current-items="updateCurrentItems" :mobile-breakpoint="2" :items-per-page.sync="rows" :search="search" v-model="selected" :headers="the_headers" :items="all_data" item-key="user_id" class="elevation-0" :footer-props="{itemsPerPageOptions:[10,25,50,100]}" :loading="loading" :options.sync="options">
                        <template v-slot:item.Tenants="{ item }">
                            <span>
                                <span v-for="t in item.Tenants" :k="item.ID">{{t.Tenant}}, &nbsp</span>
                            </span>
                        </template>
                        <template v-slot:item.user_id="{ item, ix }">
                            <v-btn icon color="primary" @click="editStaff(item)">
                                <v-icon>fas fa-edit</v-icon>
                            </v-btn>
                            <q-delete-confirmation :key="'delete' + ix" text="Are you sure you want to delete this staff account?" title="Delete Staff" :item="item" v-on:delete="deleteStaff"></q-delete-confirmation>
                        </template>
                        <template v-slot:item.blocked="{ item }">
                            <v-switch color="red" v-model="item.blocked" v-on:change="toggleBlocked(item)"></v-switch>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>
<script>
import QGenericDataTableMixin from "./QGenericDataTableMixin"
import QDeleteConfirmation from "@/components/utils/QDeleteConfirmation.vue"
import QuilityAPI from '@/store/API/QuilityAPI.js'
import { debounce } from 'vue-debounce'

export default {
    name: "QStaffDataTable",
    props: ["tenantId"],
    mixins: [QGenericDataTableMixin],
    data: function() { // data internal to component (not available outside)
        return {
            //use this to "preset" a filter
            filters: {},
            options: {
                'sortBy': [],
                'sortDesc': [true]
            },
            expanded: []
        }
    },
    computed: {
        loading: function() {
            return this.data_loading;
        },
        all_data: function() {
            if (this.hasRole('Staff')) {
                return this.the_data.filter((item) => {
                    return !item.email.endsWith('@quility.com')
                })
            }

            return this.the_data;
        },
        filter_keys: function() {
            return [];
        },
        total_items: function() {
            return this.total_num;
        },
        the_headers: function() {
            return [{
                    text: 'Name',
                    value: 'name',
                }, {
                    text: 'Email',
                    value: 'email',
                    align: "left"
                }, {
                    text: 'Tenants',
                    value: 'Tenants',
                    align: "left"
                }, {
                    text: 'Logins',
                    value: 'logins_count',
                    align: "center"
                }, {
                    text: 'Blocked',
                    value: 'blocked',
                    align: "left"
                }, {
                    text: '',
                    value: 'user_id',
                },

            ]
        },
    },
    methods: {
        loadData: debounce(function(opt) {
            var g = this
            this.data_loading = true
            g.$set(g, 'the_data', []);
            QuilityAPI.getTenantStaff(this.tenantId).then(function(json) {
                g.data_loading = false
                if (typeof json.response != 'undefined' && json.response.clientError) {
                    g.showError(json.response.body.message);
                    return
                }
                g.$set(g, 'the_data', json.data);
                g.total_num = json.data.length;
            }).catch(function(err) {
                g.data_loading = false
                if (err.status == 431) {
                    g.showError(err + " You probably need to clear all your cookie and session variables and login again.")
                    return
                }
                g.showError(err.message);
            });
            this.firstPull = false;
        }, 200),
        editStaff: function(user) {
            this.$emit("edit", user)
        },
        deleteStaff: function(item) {
            //confirm delete
            var g = this
            g.data_loading = true
            QuilityAPI.deleteTenantStaff(item, this.tenantId).then(function(json) {
                g.data_loading = false
                for (var i = 0; i < g.the_data.length; i++) {
                    if (item.user_id == g.the_data[i].user_id) {
                        g.the_data.splice(i, 1);
                        break;
                    }

                }
            });
        },
        toggleBlocked: function(item) {
            //confirm delete?
            var g = this
            this.data_loading = true;

            //now process the promise. 
            QuilityAPI.editTenantStaff(item, this.tenantId).then(function(resp) {
                    if (resp.success !== true) {
                        g.error = resp.msg
                        setTimeout(function() { g.error = null }, 6000)
                    } else {

                    }
                    g.data_loading = false;
                })
                .catch(function(err) {
                    g.error = err.msg
                    setTimeout(function() { g.error = null }, 6000)
                    g.data_loading = false;
                });
        }
    },
    watch: {
        'tenantId': function() {
            this.$nextTick(this.refreshData);
        }
    },
    components: {
        QDeleteConfirmation
    }
}
</script>
<style scoped>
.nowrap {
    white-space: nowrap;
}
</style>